import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Courses from "./pages/Courses";
import Contact from "./pages/Contact";
// import Mentoring from './pages/Mentoring';
import FreeCourses from "./pages/FreeCourses";
import RecordedClasses from "./pages/PremiumCoursesPage";
import EventRegistrationForm from "./components/EventRegistrationForm";
import EnrollmentForm from "./components/EnrollmentForm";
import RecordedCourseDetail from "./pages/RecordedCourseDetail";
// import PremiumCoursesPage from './pages/PremiumCoursesPage';
import LiveCourseDetail from "./pages/LiveCourseDetail";
import Login from "./components/Login";
import StudentDashboard from "./components/StudentDashboard";
import Signup from './components/Signup';
import CourseBrochure from "./pages/CourseBrochure";
import BusinessAnalystBrochure from "./pages/BusinessAnalystCourseBrochure";
import  AdvancedApexBrochure from "./pages/AdvancedApexBrochure";
import LWCBrochure from "./pages/LWCBrochure"; 
import SalesforceAIBootcamp from "./pages/SalesforceAIBootcamp";
import FloatingWhatsUp from "./components/FloatingWhatsUp";
import About from "./pages/AboutCodeXLNC";
import FloatingEventsPanel from "./components/FloatingEventsPanel";
import "./App.css";

const studentData = {
  name: 'Ayesha Khan',
  roll: 'CS2023005',
  email: 'ayesha.khan@example.com',
  department: 'Computer Science',
  attendance: 92,
  cgpa: 8.7,
  projects: 3,
  profileImage: 'https://randomuser.me/api/portraits/women/44.jpg'
};


function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/enroll" element={<EnrollmentForm />} />

            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/mentoring" element={<Mentoring />} /> */}
            <Route path="/free-courses" element={<FreeCourses />} />
            <Route path="/recorded-classes" element={<RecordedClasses />} />
            <Route path="/about" element={<About />} />

            {/* <Route path="/" element={<PremiumCoursesPage />} /> */}
            <Route path="/courses/:courseId" element={<LiveCourseDetail />} />
            <Route
              path="/premium-courses/:courseId"
              element={<RecordedCourseDetail />}
            />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<StudentDashboard student={studentData}/>} />
            <Route path="/whatsapp" element={<FloatingWhatsUp />} />

            {/* Add more routes as needed */}
            <Route path="/salesforce-platform-developer" element={<CourseBrochure />} />
            <Route path="/salesforce-business-analyst" element={<BusinessAnalystBrochure />} />
            <Route path="/salesforce-lwc-developer" element={<LWCBrochure />} />
            <Route path="/advanced-apex-developer" element={ <AdvancedApexBrochure/>} />
            <Route path="/salesforce-ai-bootcamp" element={<SalesforceAIBootcamp />} />
          </Routes>

          <div className="App">
            {/* Your other components */}
          <FloatingWhatsUp registerPanelPosition="right" />
          </div>
          
          <div className="App">
            {/* Your other components */}
          <FloatingEventsPanel />
          </div>
        </main>
        <Footer />
        <EventRegistrationForm />
      </div>
    </Router>
  );
}

export default App;
